/**
 * Ferme une page aux lecteurs, sans exiger le niveau administrateur.
 *
 * Voir `admin.ts` pour la dependance a `auth.global.ts`.
 */
export default defineNuxtRouteMiddleware(() => {
  const { canExportRnic } = useAuthorization()

  if (!canExportRnic.value) {
    throw createError({
      statusCode: 403,
      message: 'Accès non autorisé en lecture seule',
    })
  }
})
